export default __webpack_public_path__ + "static/Gael-2d7b70346904d726364098032960f9c3eec02e18ef34fb75970ea991001f98c1.svg";